// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_updateUnifiedProfileSlug(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "UnifiedProfileConversionCommitted",
    "UnifiedProfileConversionOutcomeUnknown",
    "UnifiedProfileNotUnifiedError",
    "UnifiedProfileUpdateFailed",
    "UpdateUnifiedAccountProfilePayload"
  ]);
}

let variablesConverter = {"unifiedProfileSlugInput":{},"__root":{"input":{"r":"unifiedProfileSlugInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"updateUnifiedProfileSlug_UpdateUnifiedAccountProfilePayload_profile":{"f":""},"updateUnifiedProfileSlug":{"u":"response_updateUnifiedProfileSlug"}}};

let wrapResponseConverterMap = {
  response_updateUnifiedProfileSlug: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"updateUnifiedProfileSlug_UpdateUnifiedAccountProfilePayload_profile":{"f":""},"updateUnifiedProfileSlug":{"u":"response_updateUnifiedProfileSlug"}}};

let responseConverterMap = {
  response_updateUnifiedProfileSlug: unwrap_response_updateUnifiedProfileSlug
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }
],
v4 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "UnifiedProfileNotUnifiedError",
  "abstractKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "UnifiedProfileConversionCommitted",
  "abstractKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "UnifiedProfileConversionOutcomeUnknown",
  "abstractKey": null
},
v7 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "UnifiedProfileUpdateFailed",
  "abstractKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publicUrl",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "MarketingProfileURLDetails",
  "kind": "LinkedField",
  "name": "urlDetails",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "baseUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnifiedAccountProfileUrlSettingsSlugMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateUnifiedProfileSlug",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "UnifiedProfileSave_updatedAccountProfile"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "UpdateUnifiedAccountProfilePayload",
            "abstractKey": null
          },
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnifiedAccountProfileUrlSettingsSlugMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateUnifiedProfileSlug",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isAccountProfile"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/)
                    ],
                    "type": "IndividualAccountProfile",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "teamName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "brokerage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "website",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "about",
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MarketingProfileSocialAccounts",
                        "kind": "LinkedField",
                        "name": "socialAccounts",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "facebook",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "instagram",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "linkedIn",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "twitter",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "yelp",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "youTube",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tikTok",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfilePhoto",
                        "kind": "LinkedField",
                        "name": "logo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "width",
                                "value": 320
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": "url(width:320)"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnifiedProfileImage",
                        "kind": "LinkedField",
                        "name": "unifiedTeamPhoto",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "width",
                                "value": 960
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": "url(width:960)"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "TeamAccountProfile",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "UpdateUnifiedAccountProfilePayload",
            "abstractKey": null
          },
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "96c804f816b5b4e329ff0911aaae16ca",
    "id": null,
    "metadata": {},
    "name": "UnifiedAccountProfileUrlSettingsSlugMutation",
    "operationKind": "mutation",
    "text": "mutation UnifiedAccountProfileUrlSettingsSlugMutation(\n  $input: UnifiedProfileSlugInput!\n) {\n  updateUnifiedProfileSlug(input: $input) {\n    __typename\n    ... on UpdateUnifiedAccountProfilePayload {\n      __typename\n      profile {\n        __typename\n        ...UnifiedProfileSave_updatedAccountProfile\n        ... on Node {\n          __isNode: __typename\n          __typename\n          nodeId\n        }\n      }\n    }\n    ... on UnifiedProfileNotUnifiedError {\n      message\n    }\n    ... on UnifiedProfileConversionCommitted {\n      message\n    }\n    ... on UnifiedProfileConversionOutcomeUnknown {\n      message\n    }\n    ... on UnifiedProfileUpdateFailed {\n      message\n    }\n  }\n}\n\nfragment UnifiedProfileSave_updatedAccountProfile on AccountProfile {\n  __isAccountProfile: __typename\n  __typename\n  ... on IndividualAccountProfile {\n    nodeId\n    publicUrl\n    urlDetails {\n      baseUrl\n      slug\n    }\n  }\n  ... on TeamAccountProfile {\n    nodeId\n    teamName\n    brokerage\n    website\n    about\n    publicUrl\n    urlDetails {\n      baseUrl\n      slug\n    }\n    socialAccounts {\n      facebook\n      instagram\n      linkedIn\n      twitter\n      yelp\n      youTube\n      tikTok\n    }\n    logo {\n      url(width: 320)\n    }\n    unifiedTeamPhoto {\n      url(width: 960)\n    }\n  }\n}\n"
  }
};
})());

let wrap_response_updateUnifiedProfileSlug = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_updateUnifiedProfileSlug = unwrap_response_updateUnifiedProfileSlug;
exports.wrap_response_updateUnifiedProfileSlug = wrap_response_updateUnifiedProfileSlug;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
